export default class Api {
  static url = "https://api.openweathermap.org";
  static key = "53551bbf2ab7d7e68f94a20c22d68b6b";
}
